import Trade from "./../Images/ExploreOurServices/Trade.svg";
import Storage from "./../Images/ExploreOurServices/Storage.svg";
import Finance from "./../Images/ExploreOurServices/Finance.svg";
export const ExploreOurServicesData = [
  {
    title: "Trade",
    firstHeading: "Post Trade Requirements",
    secondHeading: "Connect with like minded buyers",
    firstLink: "/post-your-requirements",
    secondLink: "/buyers?limit=10 ",
    image: Trade,
  },
  {
    title: "Storage",
    firstHeading: "10K+ listings of Best Storage Locations",
    secondHeading: "Release and Transfer stock effortlessly",
    firstLink: "/warehouse/find-a-warehouse",
    secondLink: "/my-storage/commodities",
    image: Storage,
  },
  {
    title: "Finance",
    firstHeading: "Get Loan against your Commodity",
    secondHeading: "Make Quick, Easy and Safe Payments",
    firstLink: "/loan-against-commodity-Page-Form",
    secondLink: "/finance",
    image: Finance,
  },
];
